<template>
    <div class="import-tool">
        <Modal v-model="visible" title="禁用" :mask-closable="false" width="400" :footer-hide="true" class="top import-tool-modal2">
            <div class="box">
                <p class="text1">请确认是否{{ enable?"启用":"禁用" }}此内勤人员的账号？</p>
            </div>

            <div class="box">
                <p class="text1" v-if="enable==0">禁用后此账号将无法登录系统后台！</p>
                <p class="text1" v-else>启用后此账号支持登录系统后台！</p>
            </div>

            <div class="ivu-modal-footer">
                <Button type="text" @click="visible = false">取消</Button>
                <Button type="primary" @click="save">确认</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    props: ['initList'],

    data() {
        return {
            visible: false,
            formData: {},
            enable:null
        };
    },
    methods: {
        open(data, enable) {
            this.formData = JSON.parse(JSON.stringify(data));
            this.enable = enable;
            this.visible = true;
        },

        save() {
            const formData = JSON.parse(JSON.stringify(this.formData));
            let data = {
                id:formData.id,
                enable: this.enable
            };

            this.$http({
                url: '/buz/usersExt/updateStatus',
                type: 'POST',
                data,
                apiPermissionCode:'org_10_4'
            }).then(res => {
                this.visible = false;
                this.$notice.success('提交成功');
                this.initList();
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
    .ivu-modal-header-inner {
        font-size: 14px;
        font-weight: bold;
        color: #3c464f;
    }
    .ivu-modal-close {
        top: 4px;
        .ivu-icon-ios-close {
            font-size: 30px;
            color: #a8adb7;
        }
    }
    .ivu-modal-header {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
    }
    .box {
        font-size: 13px;
        text-align: center;
        .text1 {
            color: #515c6f;
            margin-bottom: 15px;
        }
    }
    .ivu-modal-footer {
        border-top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 30px;
    }
}
</style>
